import { useState, useEffect } from 'react';
import { publicEventService } from '../services/publicEventService';

export function useEventDetail(id) {
  const [event,    setEvent]    = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [error,    setError]    = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!id) { setNotFound(true); setLoading(false); return; }

      try {
        setLoading(true);
        setError(null);
        setNotFound(false);
        const data = await publicEventService.getEventById(id);
        if (!cancelled) {
          if (!data) setNotFound(true);
          else setEvent(data);
        }
      } catch (err) {
        if (!cancelled) setError('Não foi possível carregar o evento.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => { cancelled = true; };
  }, [id]);

  // Título da aba é gerenciado via <SeoHead> em EventDetailPage.jsx
  // (react-helmet-async) — não mais aqui, pra não competir com ele.

  return { event, loading, notFound, error };
}
